import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useFeaturedProducts } from '../../services/productService';
import { getImageUrl } from '../../lib/supabase';
import { HERO_IMAGE } from '../../lib/constants';

/**
 * Shared auth image panel — left column on auth pages.
 * Cycles through featured product images.
 */
export function AuthImagePanel() {
  const { data: products } = useFeaturedProducts();
  const [current, setCurrent] = useState(0);

  const images = (products || [])
    .map((p) => getImageUrl(p.image_path))
    .filter(Boolean);

  useEffect(() => {
    if (images.length <= 1) return;
    const id = setInterval(() => {
      setCurrent((c) => (c >= images.length - 1 ? 0 : c + 1));
    }, 4000);
    return () => clearInterval(id);
  }, [images.length]);

  const src = images.length > 0 ? images[current] : HERO_IMAGE;

  return (
    <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.img
          key={src}
          src={src}
          alt="Product"
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </AnimatePresence>
      <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/60 to-transparent" />
      <div className="absolute bottom-8 left-8 z-10">
        <span className="text-3xl font-extrabold text-brand-white italic tracking-tight drop-shadow-lg">
          smothers
        </span>
        <p className="text-sm text-brand-white/70 mt-1">Admin Panel</p>
      </div>
    </div>
  );
}
